<script>
  import { getContext } from "svelte";
  import ButtonLabel from '#lib/ButtonLabel.svelte';
  import t from "#lib/i18n.svelte.js";

  let {
    class: css_class = ''
  } = $props();

  let entry_api = getContext("entry_api");

  function onkeydown(e) {
    if (e.key === 'e' && e.metaKey) {
      entry_api.start_editing();
    }
  }
</script>

<button
  class={css_class}
  onclick={() => {entry_api.start_editing()}}
  title={t('edit')}
  style='--button-outer-block-spacing: var(--default-button-outer-block-spacing)'
> 
  <ButtonLabel variant='brand flush text-compact' align='center' start_icon='pencil' />
</button>

<svelte:window {onkeydown} />